import { EvidenceOverview } from "@/features/oversight/evidence";

export default function EvidencePage() {
  return <EvidenceOverview />;
}
